import * as React from 'react';
import styles from './aggregate-category.scss';
import { SelectionTypeProps } from '../../types';
import { SelectionType, SelectionValue } from '../../types-fields';
import { SelectItem } from 'app/area/reports/types';
import { mapToMenuItem, DropdownField } from 'app/area/reports/components/dropdown-field';
import { RadioSymbol, LoadOptions, ComplexValue } from 'ui';
import { SelectSingle } from 'app/area/shared/translated-components';
import { OptionsType } from 'ui/common/select/types';

type AggregateCategoryComponentProps = SelectionTypeProps

interface AggregateCategoryComponentState {
  loadOptions: LoadOptions;
}

class AggregateCategoryComponent extends React.Component<AggregateCategoryComponentProps, AggregateCategoryComponentState> {
  public state: Readonly<AggregateCategoryComponentState> = {
    loadOptions: {}
  };

  private getCategoryOrDefault = (value: SelectionValue) => {
    const existingCategory = !!this.props.selectionItem.categories && !!value.category
      && this.props.selectionItem.categories.find(c => c.value === value.category.value);
    if (!!existingCategory) {
      return existingCategory;
    }
    return !!this.props.selectionItem.categories && !!this.props.selectionItem.categories.length && this.props.selectionItem.categories[0];
  };
  private handleOnChange = () => {
    const { selectionItem } = this.props;
    if (!!selectionItem.levels
      && !!selectionItem.levels.length
      && !!selectionItem.categories
      && !!selectionItem.categories.length) {
      this.props.onChange({
        ...this.props.selectionField.value,
        level: this.props.selectionItem.levels[0],
        category: this.props.selectionItem.categories[0],
        type: SelectionType.AggregateCategory
      });
    }
  };

  private onSelectLevel = (level: SelectItem) => {
    this.props.onChange({
      ...this.props.selectionField.value,
      level: level
    });
  };

  private handleChange = (item: SelectItem) => {
    this.props.onChange({
      ...this.props.selectionField.value,
      category: !!item ? item : { value: 0 }
    });
  };

  private handleLoadOptions = (loadOptions: LoadOptions) => {
    this.setState({
      loadOptions: loadOptions
    });
  };

  public render(): JSX.Element {
    const {
      selectionField: {
        value
      },
      selectionItem,
      checked,
      translation
    } = this.props;
    const {
      loadOptions: {
        query = ''
      }
    } = this.state;

    const selectedLevel = value.level && selectionItem.levels.find(o => o.value === value.level.value);
    const selectedLevelOption = selectedLevel && mapToMenuItem(selectedLevel);
    const levelOptions = selectionItem.levels.map(l => mapToMenuItem(l, () => this.onSelectLevel(l)));

    const selectedCategory = this.getCategoryOrDefault(value);
    const uniqueId = `aggregate-category-${this.props.selectionField?.selectionNo}`;

    const filteredOptions = !!query
      ? selectionItem.categories.filter(
        c => c.description.toLocaleLowerCase().includes(query.toLocaleLowerCase()) ||
             c.allLevelDescription?.toLocaleLowerCase()?.includes(query.toLocaleLowerCase())
      )
      : selectionItem.categories;
    return (
      <div className={styles.aggregateCategory}>
        <input
          type="radio"
          className="form-check-input visuallyhidden"
          id={uniqueId}
          value={value.type}
          checked={checked}
          onChange={this.handleOnChange}
        />
        <label
          className="form-check-label"
          htmlFor={uniqueId}>
          <RadioSymbol />
          {selectionItem.label}
        </label>
        {
          checked && <div className="input-wrapper">
            {selectedLevelOption && <DropdownField selectedItem={selectedLevelOption}
              options={levelOptions} />}
            <SelectSingle
              componentId={'aggr-cat'}
              label={{ text: translation.group_by_limit_to_category }}
              className={styles.categoryList}
              valueItem={selectedCategory as ComplexValue<number>}
              options={filteredOptions as ComplexValue<number>[]}
              onChange={this.handleChange}
              onLoadOptions={this.handleLoadOptions}
              optionsDisplaySetting={{ type: OptionsType.flat }}
              onLoadOptionsDelay={0}
            />
          </div>
        }
      </div>
    );
  }
}

export const AggregateCategory = AggregateCategoryComponent;
